module.exports = __webpack_public_path__ + "img/UnderConstruction.f7603391.png";